// src/api/axios.js
import axios from "axios";

const domain = window.location.hostname;
const domainFull = window.location.origin;

let apiKey;
let baseURL;
let crmbaseURL;
let SiteName;
let ProposalUrl = 'https://ozilconnect.com';
if (domain === "127.0.0.1" || domain === "localhost") {
  // SiteName = "franchise_goertrip";
  SiteName = "clickpaytrip";
  crmbaseURL = "http://127.0.0.1:8000";
  baseURL = "https://api.ozilcrm.com/api";
  ProposalUrl = "https://ozilcrm.com";
  apiKey = "F4yYTHir2gkdhUjG7JGM8AMerjxUqZF4Cyy7aKT4XmXGuKILo4AddlnuVwMycMw7w11OZd9RA8STgF9o";
  // apiKey = "Ndzg2GHZ2277pGrAYS0NZJgTOiMXF2z8VmoWCRIay8sPbf0Xig4rTlSy57ObY1HYK2QrxAxnEFc8zvOj";
} else if (domain === "goertrip.club" || domain === "www.goertrip.club" || domain === "www.goertrip.com" || domain === "goertrip.com") {
  SiteName = "goertrip";
  baseURL = "https://api.og5.in/api"; //"https://api.ozilconnect.com/api";
  crmbaseURL = "https://crm.goertrip.club";
  apiKey = "2Iy4xlJpvrYsrOl4jzlgSn1RizVfz6JCBZwvDggzAFG3mOc7m9ZxkpnA6947E69yRrjgDOxJ76ugzMaa";
} else if (domain === "franchise.ozilconnect.com" || domain === "franchise.goertrip.com") {
  SiteName = "franchise_goertrip";
  baseURL = "https://api.og5.in/api"; //"https://api.ozilconnect.com/api";
  crmbaseURL = "https://crm.goertrip.club";
  apiKey = "2Iy4xlJpvrYsrOl4jzlgSn1RizVfz6JCBZwvDggzAFG3mOc7m9ZxkpnA6947E69yRrjgDOxJ76ugzMaa";
} else if (domain === "holidayfly.in" || domain === "www.holidayfly.in") {
  SiteName = "holidayfly";
  baseURL = "https://api.og5.in/api"; //"https://api.ozilconnect.com/api";
  crmbaseURL = "https://ozilconnect.com";
  apiKey = "X3xQydrVeevUP7Zs2MeIjc9P2NlngnCH98FTU2YqboYOmQsXyzUTxMYK3oQC";
} else if (domain === "franchise.holidayfly.in") {
  SiteName = "franchise_goertrip";
  baseURL = "https://api.og5.in/api"; //"https://api.ozilconnect.com/api";
  crmbaseURL = "https://ozilconnect.com";
  apiKey = "F4yYTHir2gkdhUjG7JGM8AMerjxUqZF4Cyy7aKT4XmXGuKILo4AddlnuVwMycMw7w11OZd9RA8STgF9o";
} else if (domain === "b2b.ozilcrm.com" || domain === "www.b2b.ozilcrm.com") {
  // SiteName = "franchise_goertrip";
  SiteName = "holidayfly";
  baseURL = "https://api.ozilcrm.com/api";
  crmbaseURL = "https://ozilcrm.com";
  ProposalUrl = "https://ozilcrm.com";
  apiKey = "F4yYTHir2gkdhUjG7JGM8AMerjxUqZF4Cyy7aKT4XmXGuKILo4AddlnuVwMycMw7w11OZd9RA8STgF9o";
} else if (domain === "b2b.ziatravels.co.in" || domain === "www.b2b.ziatravels.co.in") {
  SiteName = "ziatravels";
  baseURL = "https://api.ozilconnect.com/api";
  crmbaseURL = "https://crm.ziatravels.co.in";
  apiKey = "ppSXvvZlneSU92QR97nPNBQ2B3rRtPZwLWq8Q4LBkYDsG4RnaVBBmKVO8s1tyBwcVfpY6nB91OGYtdoK";
} else if (domain === "b2b.clickpaytrip.com" || domain === "www.b2b.clickpaytrip.com" || domain === "clickpaytrip.com" || domain === "www.clickpaytrip.com") {
  SiteName = "clickpaytrip";
  baseURL = "https://api.ozilconnect.com/api";
  crmbaseURL = "https://ozilconnect.com";
  apiKey = "ffRfnc3cUqYZcQghc5oewPAFCIg8JZEbRjtevUss3wxv5RH3FDyakZxUrj3SwJ4psxhzXrvITgOSiVUV";
} else if (domain === "colb2b.ozilcrm.com" || domain === "www.colb2b.ozilcrm.com") {
  SiteName = "colb2b";
  baseURL = "https://api.ozilcrm.com/api";
  crmbaseURL = "https://ozilcrm.com";
  ProposalUrl = "https://ozilcrm.com";
  apiKey = "UmlAa5yWEi8aeqHa0iYAubUYdjmAgWih3reC4fHNVjxmPeUuaPVDJYI05gZbe0SzEvCGL3qAmqyZSKl2";
} else {
  SiteName = "";
  baseURL = "http://127.0.0.1:8081/api";
  apiKey = "";
  ProposalUrl = "";
  crmbaseURL = "http://127.0.0.1:8000/";
}
export function getapiKey() {
  return apiKey;
}
export function getbaseURL() {
  return baseURL;
}
export function getdomainName() {
  return domain;
}
export function getSiteName() {
  return SiteName;
}
export function getcrmbaseURL() {
  return crmbaseURL;
}
export function getProposalURL() {
  return ProposalUrl;
}
export function getdomainFullURL() {
  return domainFull;
}
// console.log(apiKey);
// console.log(domain);

const api = axios.create({
  baseURL: baseURL, // Your base API URL
  // baseURL: 'http://127.0.0.1:8081/api', // Your base API URL
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    } else {
      config.headers.apiKey = apiKey;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
